// components
import { Placeholder } from 'rsuite';
// styles
import styles from './AgreementCardSkeleton.module.css';

const AgreementCardSkeleton = () => {
    return (
        <div className={styles['wrapper']}>
            <div className={styles['description']}>
                <Placeholder.Paragraph rows={1} active className={styles['name']} />
                <Placeholder.Paragraph rows={1} active className={styles['quantity']} />
                <Placeholder.Paragraph rows={1} active className={styles['updated_at']} />
                <Placeholder.Paragraph rows={1} active className={styles['next_to_expire']} />
                <Placeholder.Paragraph rows={1} active className={styles['pdv']} />
            </div>
        </div>
    );
};

export default AgreementCardSkeleton;
